import r from "microdiff";
import e from "p5";
import t from "react";
var _n = function n() {
  return _n = Object.assign || function (r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) for (var o in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, o) && (r[o] = e[o]);
    return r;
  }, _n.apply(this, arguments);
};
function o(r, e) {
  var t = {};
  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (null != r && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (n = Object.getOwnPropertySymbols(r); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[o]) && (t[n[o]] = r[n[o]]);
  }
  return t;
}
var c = "react-p5-wrapper",
  u = t.memo(function (r) {
    var e = r.sketch,
      c = o(r, ["sketch"]);
    if (void 0 === e) return console.error("[ReactP5Wrapper] The `sketch` prop is required."), null;
    return t.createElement(f, _n({
      sketch: e
    }, c));
  }, function (e, t) {
    return 0 === r(e, t).length;
  });
function i(r) {
  var e;
  null === (e = r.current) || void 0 === e || e.remove(), r.current = void 0;
}
function f(r) {
  var n = r.sketch,
    c = r.children,
    u = o(r, ["sketch", "children"]),
    f = t.createRef(),
    a = t.useRef();
  return t.useEffect(function () {
    null !== f.current && (i(a), a.current = function (r, t) {
      return new e(r, t);
    }(n, f.current));
  }, [n]), t.useEffect(function () {
    var r, e;
    null === (e = null === (r = a.current) || void 0 === r ? void 0 : r.updateWithProps) || void 0 === e || e.call(r, u);
  }, [u]), t.useEffect(function () {
    return function () {
      return i(a);
    };
  }, []), t.createElement("div", {
    ref: f,
    className: "react-p5-wrapper"
  }, c);
}
export { c as P5WrapperClassName, u as ReactP5Wrapper };